import {
  Column,
  Loading,
  RadioButton,
  RadioButtonGroup,
  Row,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { PieChart, StackedBarChart } from "@carbon/charts-react";

const pieChartOptions = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "200px",
};

const pieChartOptions1 = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "400px",
};

const barChartOptions = {
  title: "",
  axes: {
    left: { mapsTo: "value" },
    bottom: { mapsTo: "group", scaleType: "labels" },
  },
  height: "400px",
};

const options = {
  title: "",
  axes: {
    left: {
      mapsTo: "value",
      stacked: true,
    },
    bottom: {
      mapsTo: "key",
      scaleType: "labels",
    },
  },
  height: "400px",
};
const DashboardPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [windowCode, setWindowCode] = useState("1");
  const [stats, setStats] = useState({});
  const [candidaturesByGender, setCandidaturesByGender] = useState([]);
  const [candidaturesByProvince, setCandidaturesByProvince] = useState([]);
  const [businessPlansByGender, setBusinessPlansByGender] = useState([]);
  const [businessPlansByProvince, setBusinessPlansByProvince] = useState([]);

  const getStats = async () => {
    try {
      setIsLoading(true);
      const response = await http.get(`/stats?windowCode=${windowCode}`);
      setStats(response.data);
      setCandidaturesByGender(response.data.candidaturesByGender);
      setCandidaturesByProvince(response.data.candidaturesByProvince);
      // Business plan indicators - scoped to the selected window, since a
      // candidate may have a plan per Janela (candidaturas above stay the
      // same regardless, as there is only ever one per candidate).
      setBusinessPlansByGender(response.data.businessPlansByGender);
      setBusinessPlansByProvince(response.data.businessPlansByProvince);
      setIsLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar dados estatísticos");
    }
  };

  useEffect(() => {
    getStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowCode]);

  return (
    <>
      <h3>Dashboard</h3>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <div className="dashboard">
        {/* Governs the whole dashboard below. A candidate only ever has one
            ApplicationForm (Janela 1), so "candidaturas da Janela 2" means
            candidates the admin has approved for Janela 2 (eligibleForWindow2),
            not a second candidatura row - see StatsService#getStats. */}
        <Row>
          <Column>
            <RadioButtonGroup
              legendText="Janela"
              name="dashboard-window"
              valueSelected={windowCode}
              onChange={(value) => setWindowCode(value)}
            >
              <RadioButton labelText="Janela 1" value="1" id="dashboard-window-1" />
              <RadioButton labelText="Janela 2" value="2" id="dashboard-window-2" />
            </RadioButtonGroup>
          </Column>
        </Row>
        <Row className="mt-2">
          <Column xsm={12} sm={12} lg={8} xlg={8}>
            <Card
              title={
                windowCode === "2" ? "Candidaturas Habilitadas (Janela 2)" : "Candidaturas"
              }
            >
              <table className="table table-borderless text-center">
                <tr>
                  <td>
                    <p>Total</p>
                    <h1>{stats.totalCandidatures}</h1>
                  </td>
                  <td>
                    <p>Submetidas</p>
                    <h1>{stats.totalSubmittedCandidatures}</h1>
                  </td>
                  <td>
                    <p>Elegiveis</p>
                    <h1>{stats.totalEligibleCandidatures}</h1>
                  </td>
                  <td>
                    <p>Apuradas</p>
                    <h1>{stats.totalQualifiedCandidatures}</h1>
                  </td>
                </tr>
              </table>
            </Card>
          </Column>
          <Column xsm={12} sm={12} lg={4} xlg={4}>
            <Card title="Candidaturas por Género">
              <PieChart
                data={candidaturesByGender}
                options={pieChartOptions}
              ></PieChart>
            </Card>
          </Column>
        </Row>
        <Row className="mt-2 mb-6">
          <Column>
            <Card title="Candidaturas por Província">
              <StackedBarChart
                data={candidaturesByProvince}
                options={options}
              ></StackedBarChart>
            </Card>
          </Column>
        </Row>
        <br />
        <Row className="mt-2">
          <Column xsm={12} sm={12} lg={8} xlg={8}>
            <Card title="Planos de Negócio">
              <table className="table table-borderless text-center">
                <tr>
                  <td>
                    <p>Total</p>
                    <h1>{stats.totalBusinessPlans}</h1>
                  </td>
                  <td>
                    <p>Submetidos</p>
                    <h1>{stats.totalSubmittedBusinessPlans}</h1>
                  </td>
                </tr>
              </table>
            </Card>
          </Column>
          <Column xsm={12} sm={12} lg={4} xlg={4}>
            <Card title="Planos por Género">
              <PieChart
                data={businessPlansByGender}
                options={pieChartOptions}
              />
            </Card>
          </Column>
        </Row>
        <Row className="mt-2">
          <Column>
            <Card title="Planos por Província">
              <StackedBarChart
                data={businessPlansByProvince}
                options={options}
              />
            </Card>
          </Column>
        </Row>
      </div>
    </>
  );
};

export default DashboardPage;
